import React, { Component } from 'react';
import { BrowserRouter as Router,Routes, Route, Link } from 'react-router-dom';
// import {Route, Switch} from 'react-router-dom';
import Home from './Pages/Home';
import Event from './Pages/Event';
import Poster from './Pages/Poster';
import './App.css';


import preloader from './assets/images/preloader.gif';
import EventDescription from './components/EventDescription';
import Timeline from './components/Timeline';
import Registration from './components/Registration';
import Prizes from './components/Prizes';
import Banner from './components/Banner';

import eventsData from './eventsData';

 
class App extends Component {
  render() {
    return (
       <Router>
           <div className="App">
            {/* <ul className="App-header">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
              <link rel="stylesheet" href="css/animate.min.css">
<link rel="stylesheet" href="css/hamburger-menu.css">
<link rel="stylesheet" href="css/odometer.min.css">
<link rel="stylesheet" href="css/swiper.min.css">
<link rel="stylesheet" href="css/fancybox.min.css">
<link rel="stylesheet" href="css/bootstrap.min.css">
<link rel="stylesheet" href="css/style.css">
</head>
            </ul> */}
            <div class="preloader"> <img src={preloader} alt="Image"/>
        <ul class="text-rotater">
          <li>Hangin there</li>
          <li>Still loading</li>
          <li>Almost done</li>
        </ul>
      </div>
           <Routes>
           <  Route exact path='/' element={< Event />}></Route>
                 <Route exact path='/:id' element={< Event />}></Route>
                 {/* <Route path='/event/:id' render = {props =>(<Event eventsData={eventsData} />)}></Route> */}
                 <Route path='/event/:id' element = {<Event/>}/>
                 <Route path='/event/:name' element = {<Event/>}/>
                 <Route exact path='/event' element={< Event />}></Route>
                 <Route path='/poster/:id' element = {<Poster/>}/>
                 
                 {/* <Route exact path='/banner' element={<Banner />}></Route>
                 <Route exact path='/description' element={< EventDescription />}></Route>
                 <Route exact path='/timeline' element={< Timeline />}></Route>
                 <Route exact path='/registration' element={<Registration/>}></Route>
                 <Route exact path='/prizes' element={<Prizes/>}></Route>
                  */}
           </Routes>
          </div>
    </Router>
   );
  }
}
 
export default App;